import { messageErreur } from './errors';

/**
 * Échec d'un appel à l'API, avec le message à afficher tel quel, le code stable
 * éventuel et le corps de la réponse (détails propres à une erreur, ex. l'élève
 * qui porte déjà une adresse).
 */
export class ErreurApi extends Error {
  constructor(
    message: string,
    public readonly status?: number,
    public readonly code?: string,
    public readonly corps?: unknown
  ) {
    super(message);
    this.name = 'ErreurApi';
  }
}

interface ReponseClient<T> {
  data?: T;
  error?: unknown;
  response: Response;
}

/**
 * Données d'un appel openapi-fetch, ou ErreurApi avec le message de l'API.
 * Usage : `const data = await lire(api.GET('/api/admin/users', { … }))`.
 */
export async function lire<T>(appel: Promise<ReponseClient<T>>): Promise<T> {
  const { data, error, response } = await appel;
  if (data === undefined || !response.ok) {
    const code =
      error && typeof error === 'object' && 'code' in error && typeof error.code === 'string' ? error.code : undefined;
    throw new ErreurApi(messageErreur(error, response), response.status, code, error);
  }
  return data;
}

/** Message d'une erreur quelconque (ErreurApi, panne réseau…). */
export function messageDe(erreur: unknown): string {
  return erreur instanceof Error ? erreur.message : 'Erreur inattendue.';
}
